import styled from "styled-components";

export const ErrorModalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TextAppearance = styled.div`
  color: #000;
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: "Verizon NHG DS";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  width: 100%;
  padding-top: ${(props) => (props.isEditMode ? "36px" : 0)};
  padding-bottom: 36px;
`;

export const FrameForDragAndDrop = styled.div`
  display: flex;
  width: 100%;
  height: 152px;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9px;
  border-radius: 4px;
  border: 1px dashed #000;
  background: var(--white, #fff);

  &:has(+ div) {
    margin-bottom: 36px;
  }
`;

export const InnerFrameForDragAndDrop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: auto;
  height: auto;

  & > label:focus-within {
    outline: none;
  }
`;

export const FrameForImageDesc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: auto;
  height: auto;
`;

export const ImageDescription = styled.span`
  color: #000;
  text-align: center;
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: "Verizon NHG DS";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
`;

export const ImageCardContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 470px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background: #d8dada;
  }

  &::-webkit-scrollbar-thumb {
    background: #000000;
    border-radius: 4px;
    width: 2px;
    max-height: 105px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #888 #d8dada;
`;

export const FrameForFileUploader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 9px;
`;

export const FrameForUploadIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 99px;
  border: 1px solid rgba(111, 113, 113, 0.06);
  background: rgba(111, 113, 113, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UploadText = styled.div`
  color: #000;
  text-align: center;
  font-feature-settings:
    "clig" off,
    "liga" off;
  font-family: "Verizon NHG DS";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  color: #666;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ImageCardItem = styled.div`
  display: flex;
  margin-top: 36px;
  justify-content: space-evenly;
  position: relative;

  &:first-child {
    margin-top: 0;
  }
`;

export const ImageCardContent = styled.div`
  padding: 18px 24px;
  background: #ffffff;
  max-width: 732px;
  width: 100%;
  border-radius: 4px;
`;

export const ImageCardInner = styled.div`
  display: flex;
  align-items: center;
  gap: 52px;
`;

export const ImageCardDeleteButtonContainer = styled.div`
  align-self: center;
  padding: 0 4px;
`;

export const CardImageContainer = styled.div`
  position: relative;
  width: 81px;
  height: 81px;
  flex-shrink: 0;
  display: flex;
  gap: 4px;
`;

export const SectionLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const UploadHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CardImage = styled.img`
  height: 81px;
  width: 81px;
  object-fit: cover;
`;

export const CardFileName = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #000;
  font-family: "Verizon NHG DS";
  max-width: 300px;
  word-wrap: break-word;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-decoration: underline;
    text-decoration-style: dotted;
  }
`;

export const CardValidationStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 160px;
  width: 100%;
  gap: 10px;
  margin-left: auto;

  & > #image_badge {
    background-color: #b95319;
    color: #ffffff;
  }
`;

export const CardValidationDesc = styled.span`
  font-size: 14px;
  color: #b95319;

  & #retry_icon {
    cursor: pointer;
  }
`;
